import { useQuery } from 'react-query';
import type { QueryStatus } from 'react-query';
import { getDefaultWatchlistsResponse, queryFn } from './queryFn';
import type { Response } from './queryFn';

export const QUERY_KEY = 'WATCHLISTS';

export interface WatchlistsResponse extends Response {
  status: QueryStatus;
  isFetching: boolean;
  isFetched: boolean;
}

export default function useWatchlists(): WatchlistsResponse {
  const {
    data = getDefaultWatchlistsResponse(),
    status,
    isFetched,
    isFetching,
  } = useQuery(QUERY_KEY, queryFn, {
    staleTime: 3600000,
    retry: 1,
  });
  const { watchlists, watchlistsKeys } = data;
  return {
    watchlists,
    watchlistsKeys,
    isFetching,
    status,
    isFetched,
  };
}
